import { render, staticRenderFns } from "./site-scanner-summary-card.vue?vue&type=template&id=8e4d8910&scoped=true"
import script from "./site-scanner-summary-card.vue?vue&type=script&lang=js"
export * from "./site-scanner-summary-card.vue?vue&type=script&lang=js"
import style0 from "./site-scanner-summary-card.vue?vue&type=style&index=0&id=8e4d8910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4d8910",
  null
  
)

export default component.exports